import { useSEO } from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { FeatureCard } from "@/components/FeatureCard";
import { Reveal } from "@/components/Reveal";
import { FEATURE_CATEGORIES } from "@/data/features";

export default function Features() {
  useSEO({
    title: "Features",
    description:
      "Explore Xevon's modules — moderation, security, tickets, leveling, social, voice, utility, and fun.",
    path: "/features",
  });

  return (
    <>
      <PageHeader
        kicker="Features"
        title="Everything your server needs. Nothing it doesn't."
        description="Sixteen deeply integrated modules, each built to feel native to Discord. Every feature below is live in Xevon today."
      />
      <section className="mx-auto w-full max-w-7xl px-6 pb-32" data-testid="features-grid">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURE_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={(i % 3) * 0.08}>
              <div id={cat.id} className="scroll-mt-28">
                <FeatureCard
                  icon={cat.icon}
                  title={cat.title}
                  description={cat.description}
                  items={cat.items}
                  testId={`feature-card-${cat.id}`}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
